export const UNAUTHORIZED_ROUTE_PATHS = {
  LOGIN: '/login'
};

export const ROUTE_PATHS = {
  ROOT: '/',
  CUSTOMERS: '/customers',
  CUSTOMER_CORPORATE: '/customers/corporative/:id',
  CUSTOMER_INDIVIDUAL: '/customers/individual/:id',
  ACTIVE_CUSTOMERS: '/active-customers',
  ACTIVE_CUSTOMER_CORPORATE: '/active-customers/corporative/:id',
  ACTIVE_CUSTOMER_INDIVIDUAL: '/active-customers/individual/:id',
  USERS: '/users',
  USER_DETAILS: '/users/:id',
  USER_CREATE: '/users/create',
  ACCOUNTS: '/accounts',
  SYSTEM_ACCOUNTS: '/system-accounts',
  TRANSACTIONS: '/transactions',
  TRANSACTION_DETAILS: '/transactions/:id',
  TRANSIT_TRANSACTIONS: '/transit-transactions',
  CREATE_TRANSACTION: '/new-transaction',
  CREATE_PAYMENT_TRANSACTION: '/new-transaction/payment',
  CREATE_TRANSIT_TRANSACTION: '/new-transaction/transit',
  CREATE_COMMISSION_TRANSACTION: '/new-transaction/commission',
  CREATE_CRYPTO_TRANSACTION: '/new-transaction/crypto',
  CREATE_EXCHANGE_TRANSACTION: '/new-transaction/exchange',
  CREATE_REPEAT_TRANSACTION: '/new-transaction/repeat',
  TARIFFS: '/tariffs',
  TARIFFS_CREATE_GROUP: '/tariffs/create-group',
  TARIFFS_GROUP_DETAILS: '/tariffs/:id',
  LIMITS: '/limits',
  LIMITS_CREATE_GROUP: '/limits/create-group',
  LIMITS_GROUP_DETAILS: '/limits/:id',
  MARKUPS: '/markups',
  MARKUPS_GROUPS: '/markups/groups',
  MARKUPS_EXCHANGE_RATES: '/markups/exchange-rates',
  MARKUPS_CREATE_GROUP: '/markups/groups/create-group',
  MARKUPS_GROUP_DETAILS: '/markups/groups/:id',
  MESSAGES: '/messages',
  NEW_MESSAGE: '/messages/new',
  TOPIC_MESSAGES: '/messages/:id',
  COMMISSIONS: '/commissions',
  COMMISSION_ACCOUNTS: '/commissions/commission-accounts',
  COMMISSION_TRANSACTIONS: '/commissions/commission-transactions',
  COMMISSION_WITHDRAWAL: '/commissions/withdrawal-transactions',
  PAYMENT_OBLIGATIONS: '/payment-obligations',
  RECONCILIATION_REPORTS: '/reconciliation-reports',
  CARD_AUTHORIZATIONS: '/card-authorizations',
  COUNTERPARTIES: '/counterparties',
  EMAIL_STATISTICS: '/email-statistics',
  BALANCES: '/balances',
  BALANCES_DOCUMENTS: '/balances/documents',
  BALANCES_CURRENT_BALANCES: '/balances/current-balances',
  BALANCES_CUSTOMER_WALLETS_REPORT: '/balances/customer-wallets-report',
  BALANCES_CONVERA_REPORTS: '/balances/convera-reports',
  SETTINGS: '/settings',
  SETTINGS_CONFIGURATION: '/settings/configuration',
  SETTINGS_PAYMENTS_CUTOFF_TIMES: '/settings/payments-cutoff-times',
  SETTINGS_BLACKLISTS: '/settings/blacklists',
  SETTINGS_MAINTENANCE: '/settings/maintenance',
  SETTINGS_HIGH_RISK_COUNTRIES: '/settings/high-risk-countries',
  SETTINGS_DOCUMENT_REQUESTS: '/settings/document-requests',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  SETTINGS_INTEGRATION_SETTING: '/settings/integrations/:provider/:settingKey',
  EMAIL_VALIDATION_RULES: '/email-validation-rules',
  OPERATORS: '/operators',
  ...UNAUTHORIZED_ROUTE_PATHS
};

export const INITIAL_PATH_AFTER_LOGIN = ROUTE_PATHS.ROOT;
